import {PaymentAPI} from "../../../apis/PaymentAPI";

export default {
    namespaced: true,
    state: {
        subscriptionDetails: {},
        creditsDetails: {},
        loading: false,
    },
    mutations: {
        updateSubscriptionDetails(state, data) {
            state.subscriptionDetails = data;
        },
        getCreditsDetails(state, data) {
            state.creditsDetails = data;
        },
        loading(state) {
            state.loading = true;
        },
        loaded(state) {
            state.loading = false;
        }
    },
    actions: {
        async updateSubscriptionDetails(context) {
            let subscriptionDetails = await PaymentAPI.getSubscriptionDetails();
            context.commit('updateSubscriptionDetails', subscriptionDetails);
        },
        async getCredits(context) {
            let creditsDetails = await PaymentAPI.getCreditsDetails();
            context.commit('getCreditsDetails', creditsDetails);
        },
    },
    getters: {
        hasCredits: (state, getters) => {
            return state.creditsDetails && state.creditsDetails.remaining > 0;
        },
    }
}
